const m = window.require("discourse/modifiers/close-on-click-outside");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;